<template>
  <div>
    <div class="layout-messages">
      <transition-group name="p-messages" tag="div">
        <div v-for="(msg, index) in messages" :key="msg.content + index">
          <Message
            :life="msg.life"
            :sticky="msg.sticky"
            :severity="msg.severity"
            >{{ msg.content }}</Message
          >
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import Message from "primevue/message";
import { mapState } from "vuex";

export default {
  components: {
    Message: Message,
  },
  watch: {
    messages() {},
  },
  computed: {
    ...mapState(["messages"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.layout-chat {
  background-color: #6da325 !important;
  width: 107px;
  height: 50px;
  padding: 0px;
  margin: 10px 20px;
  position: fixed;
  bottom: 0px;
  overflow: visible;
  opacity: 1;
  border: 0px;
  z-index: 999998;
  transition-duration: 250ms;
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  transition-property: opacity, top, bottom;
  right: 0px;
  border-radius: 999rem;
  cursor: pointer;

  .floating-message {
    margin-top: 0.7rem !important;
    text-align: center !important;

    span {
      color: white;
      font-size: 120%;

      i {
        vertical-align: middle;
        font-size: 150% !important;
      }
    }
  }
}

.layout-messages {
  position: fixed;
  height: 50px;
  padding: 0.7em 1.5em 0em 1.5em;
  color: #ffffff;
  z-index: 999;
  right: 0;
}
</style>